// Web-SDK @app/webview-bridge/web
// Браузерная сторона моста — не содержит зависимостей от react-native.
// Подключается web-репозиторием; нативный хост использует ./src/index.ts.

export { bridge, BridgeSdk } from './bridge';
export type { EventHandler, NativeBridgeGlobal, UnsubscribeFn } from './bridge';
export { createTypedBridge } from './typed';
export type { TypedBridgeSdk } from './typed';

// Адаптер для запуска сервиса в iframe веб-оболочки (postMessage вместо нативного инжекта).
// bridge.init() ставит его автоматически; пред-установка с опциями (allowedOrigins) — до init().
export { installIframeBridge, isInsideIframe } from './iframe-adapter';
export type { InstallIframeBridgeOptions } from './iframe-adapter';

// Типы протокола — единый источник истины с нативной стороной
export { SYSTEM_ACTIONS } from '../protocol/actions';
export type {
  CloseNotification,
  CloseNotificationType,
  SystemActionPayloads
} from '../protocol/actions';
export { SYSTEM_EVENTS } from '../protocol/events';
export type { InitContext, SystemEventPayloads } from '../protocol/events';
export { PROTOCOL_VERSION } from '../protocol/protocol';
export type { NativeMessage, WebMessage } from '../protocol/protocol';
export type { TabBarConfig, TabItem } from '../protocol/tab-bar';
